import * as React from 'react';

export interface LoadingWidgetProps {
  loading: boolean;
  children: () => React.JSX.Element;
}

export const LoadingWidget: React.FC<LoadingWidgetProps> = (props) => {
  if (props.loading) {
    return null;
  }
  return props.children();
};
